import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';

import { Title } from './styles/Title';

type TProps = {
  onClose: () => void;
};

export const AutoScriptOneTutorialVideo = ({ onClose }: TProps) => {
  return (
    <ModalWrapper width="800px">
      <Title style={{ margin: '0 0 25px', textAlign: 'center' }}>AutoScriptOne User Guide</Title>
      <video
        controls
        width="100%"
        poster="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/AutoScriptOne.png"
      >
        <source src="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/AutoScriptOne.mp4" type="video/mp4" />
        <p>
          Your browser {"doesn't"} support HTML video. Here is a{' '}
          <a href="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/AutoScriptOne.mp4">link to the video</a>{' '}
          instead.
        </p>
      </video>
      <div style={{ marginTop: '20px' }}>
        <Button onClick={onClose}>Got it!</Button>
      </div>
    </ModalWrapper>
  );
};
